import React, { useState, useEffect, useContext } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
  InputAdornment,
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

import LanguageContext from "../contexts/LanguageContext"
import { renewSocket } from "../contexts/SocketContext"

const Login = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [alertMessage, setAlertMessage] = useState()
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <Helmet>
        <title>{languageValues?.loginPage?.title[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email(`${languageValues?.requiredField[actLanguage]}`).max(255).required(`${languageValues?.requiredField[actLanguage]}`),
              password: Yup.string().max(255).required(`${languageValues?.requiredField[actLanguage]}`)
            })}
            onSubmit={(values, { setSubmitting }) => {
              setAlertMessage("");
              const userData = {
                email:  values?.email?.trim()?.toLowerCase(),
                password: values.password,
                language : actLanguage,
              }
              APIS.loginUser(userData).then(result => {
                if (result?.message === "signin" && result?.user) {
                  setUser(result?.user)
                  renewSocket()
                  navigate("/")
                  return
                } else {
                  setAlertMessage(languageValues?.loginPage?.incorrectMessage[actLanguage])
                }
                setSubmitting(false);
              })

            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 2, textAlign:"center" }}>
                  <Typography
                    color="text.blackTitle"
                    variant="h2"
                  >
                    {languageValues?.loginPage?.title[actLanguage]}
                  </Typography>
                </Box>

                <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"]}}>
                  {languageValues?.loginPage?.emailField[actLanguage]}
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                  placeholder="ex. paul.durand@email.com"
                />
                <Box sx={{paddingTop:"10px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                  <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"]}}>
                    {languageValues?.loginPage?.passwordField[actLanguage]}
                  </Box>
                  <Link component={RouterLink} to="/forgotPassword" sx={{fontSize:["11px", "14px"]}}>
                    {languageValues?.loginPage?.forgotPassword[actLanguage]}
                  </Link>
                </Box>
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  value={values.password}
                  variant="outlined"
                  placeholder={languageValues?.loginPage?.passwordField[actLanguage]}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </InputAdornment>
                    ),
                  }}
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    {languageValues?.loginPage?.button[actLanguage]}
                  </Button>
                </Box>
                {alertMessage && alertMessage.length > 0 && (
                  <Box
                    sx={{
                      pb: 1,
                      pt: 0
                    }}
                  >
                    <Typography
                      align="center"
                      color="red"
                      variant="body1"
                    >
                      {alertMessage}
                    </Typography>
                  </Box>
                )}
                <Box sx={{
                  marginTop:"15px",
                  marginBottom:"15px",
                  fontSize:"16px",
                  textAlign:"center",
                  color : "text.primary",
                }}>
                  <Link
                    component={RouterLink}
                    sx={{marginLeft:"3px"}}
                    onClick={() => { window.location.href = "./eduserv/login" }}
                  >
                    {languageValues?.loginPage?.eduServicesLogin[actLanguage]}
                  </Link>
                </Box>
                <Box sx={{
                  marginTop:"15px",
                  marginBottom:"15px",
                  fontSize:"16px",
                  textAlign:"center",
                  color : "text.primary",
                }}>
                  {languageValues?.loginPage?.noAccount[actLanguage]}
                  <Link component={RouterLink} to="/register" sx={{marginLeft:"3px"}}>
                    {languageValues?.mainLayout?.itsHere[actLanguage]}
                  </Link>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
